import Link from 'next/link';
import Image from 'next/image';
import { Menu } from '@headlessui/react'

export default function BtnHeadNav(props)
{
    const { className, children, href, items } = props;

    if ( items ) {

        let arrowSrc = "/img/ui/arrow_down_01.svg";

        return (
            <Menu>
                {({ open }) => (
                <div className="relative">
                    <Menu.Button>
                        <div className={ "cursor-pointer block font-medium no-underline hover:underline flex items-center text-bb font-bold" + (className ? " " + className : "") }>
                            <span className="mr-5">{ children }</span>
                            <Image src={ arrowSrc } alt="arrow_down_01" height="6" width="9" />
                        </div>
                    </Menu.Button>
                        <Menu.Items static>
                            <Menu.Item>
                                <div className={`absolute top-60 left-0 block bg-white rounded shadow overflow-hidden transition duration-100 ease-out ${open ? 'opacity-100 scale-100' : 'opacity-0 scale-95 invisible pointer-events-none'}`}>
                                    { items }
                                </div>
                            </Menu.Item>
                        </Menu.Items>
                </div>
                )}
            </Menu>
        );
    }

    if ( href ) {
        return (
            <Link href={ href } className={ "block font-medium no-underline hover:underline flex items-center text-bb font-bold" + (className ? " " + className : "") } passHref>
                <span>{ children }</span>
            </Link>
        );
    }
    return (
        <div className={ "block font-medium no-underline flex items-center" + (className ? " " + className : "") }>
            <span>{ children }</span>
        </div>
    );
}